import type { NavItemDef } from '../navItems';

// KB navigation items - empty for now, may be used later
export const KB_NAV_ITEMS: NavItemDef[] = [];
